module.exports = __webpack_public_path__ + "img/iran-venezuela.5c48446c.png";